const moneyFormat = document.currentScript.getAttribute("money-format") || "${{amount}}";
const cartCurrencyIsoCode = document.currentScript.getAttribute("cart-currency-iso-code") || "";
const productId = document.currentScript.getAttribute("product-id") || "";
const configuratorName = document.currentScript.getAttribute("configurator-name") || "group01";
const productDiscount = Number(document.currentScript.getAttribute("product-discount")) || 0;
//const baseAppProxy = "/apps/shopqse-3d-ring-creator";
const baseAppProxy = 'https://phpstack-1090158-4665907.cloudwaysapps.com';
const three_d_static_data = {
    pmat: {
        "14k_yellow_gold": "https://cdn.shopify.com/s/files/1/0630/0300/1005/files/14KYellow.pmat",
        "14k_white_gold": "https://cdn.shopify.com/s/files/1/0630/0300/1005/files/14KWhite.pmat",
        "14k_rose_gold": "https://cdn.shopify.com/s/files/1/0630/0300/1005/files/14KRose.pmat",
        "18k_yellow_gold": "https://cdn.shopify.com/s/files/1/0630/0300/1005/files/18KYellow.pmat",
        "18k_white_gold": "https://cdn.shopify.com/s/files/1/0630/0300/1005/files/18KWhite.pmat",
        "18k_rose_gold": "https://cdn.shopify.com/s/files/1/0630/0300/1005/files/18KRose.pmat",
        platinum: "https://cdn.shopify.com/s/files/1/0630/0300/1005/files/Platinum.pmat",
    },
    dmat: {
        "14k_yellow_gold": "https://cdn.shopify.com/s/files/1/0630/0300/1005/files/Global-Diamond.dmat",
        "14k_white_gold": "https://cdn.shopify.com/s/files/1/0630/0300/1005/files/Global-Diamond.dmat",
        "14k_rose_gold": "https://cdn.shopify.com/s/files/1/0630/0300/1005/files/Global-Diamond.dmat",
        "18k_yellow_gold": "https://cdn.shopify.com/s/files/1/0630/0300/1005/files/Global-Diamond.dmat",
        "18k_white_gold": "https://cdn.shopify.com/s/files/1/0630/0300/1005/files/Global-Diamond.dmat",
        "18k_rose_gold": "https://cdn.shopify.com/s/files/1/0630/0300/1005/files/Global-Diamond.dmat",
        platinum: "https://cdn.shopify.com/s/files/1/0630/0300/1005/files/Global-Diamond.dmat",
    },
    vjson: "https://cdn.shopify.com/s/files/1/0630/0300/1005/files/ShopQ19n.vjson?v=1728282598",
};

const slickSettings = {
    productPageFilterMetalSliderSettings: {
        dots: false,
        speed: 300,
        infinite: false,
        slidesToShow: 7,
        slidesToScroll: 1,
        prevArrow:
            '<button type="button" class="slick-prev"><svg class="icon-left-cirle-arrow" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.16016 14.3198C11.1082 14.3198 14.3203 11.1077 14.3203 7.15967C14.3203 3.21162 11.1082 -0.000489516 7.16016 -0.000489861C3.21211 -0.000490206 1.74354e-08 3.21162 -3.27714e-07 7.15967C-6.72862e-07 11.1077 3.21211 14.3198 7.16016 14.3198ZM7.16016 0.89453C10.6148 0.89453 13.4253 3.705 13.4253 7.15967C13.4253 10.6143 10.6148 13.4248 7.16016 13.4248C3.70549 13.4248 0.895019 10.6143 0.895019 7.15967C0.89502 3.705 3.70549 0.894529 7.16016 0.89453ZM4.15871 7.47606C3.98384 7.30119 3.98384 7.01803 4.15871 6.84328L6.39626 4.60573C6.48363 4.51835 6.5982 4.47461 6.71265 4.47461C6.8271 4.47461 6.94166 4.51835 7.02904 4.60573C7.2039 4.78059 7.2039 5.06376 7.02904 5.23851L5.55539 6.71216L9.84522 6.71216C10.0924 6.71216 10.2927 6.91231 10.2927 7.15967C10.2927 7.40703 10.0924 7.60718 9.84521 7.60718L5.55539 7.60718L7.02904 9.08083C7.2039 9.25569 7.2039 9.53885 7.02904 9.71361C6.85417 9.88836 6.57101 9.88847 6.39626 9.71361L4.15871 7.47606Z" fill="#183E40"/></svg></button>',
        nextArrow:
            '<button type="button" class="slick-next"><svg class="icon-right-cirle-arrow" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.16 0C3.21204 0 0 3.21204 0 7.16C0 11.108 3.21204 14.32 7.16 14.32C11.108 14.32 14.32 11.108 14.32 7.16C14.32 3.21204 11.108 0 7.16 0ZM7.16 13.425C3.70541 13.425 0.895 10.6146 0.895 7.16C0.895 3.70541 3.70541 0.895 7.16 0.895C10.6146 0.895 13.425 3.70541 13.425 7.16C13.425 10.6146 10.6146 13.425 7.16 13.425ZM10.1614 6.84362C10.3362 7.01848 10.3362 7.30163 10.1614 7.47638L7.92388 9.71388C7.83651 9.80126 7.72195 9.845 7.6075 9.845C7.49305 9.845 7.37849 9.80126 7.29112 9.71388C7.11626 9.53902 7.11626 9.25587 7.29112 9.08112L8.76474 7.6075H4.475C4.22787 7.6075 4.0275 7.40736 4.0275 7.16C4.0275 6.91264 4.22787 6.7125 4.475 6.7125H8.76474L7.29112 5.23888C7.11626 5.06402 7.11626 4.78087 7.29112 4.60612C7.46598 4.43137 7.74913 4.43126 7.92388 4.60612L10.1614 6.84362Z" fill="#183E40"/></svg></button>',
        responsive: [
            {
                breakpoint: 1250,
                settings: {
                    slidesToShow: 6,
                },
            },
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 5,
                },
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 8,
                },
            },
            {
                breakpoint: 767,
                settings: "unslick",
            },
        ],
    },
    productPageFilterShapeSliderSettings: {
        dots: false,
        speed: 300,
        infinite: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        prevArrow:
            '<button type="button" class="slick-prev"><svg class="icon-left-cirle-arrow" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.16016 14.3198C11.1082 14.3198 14.3203 11.1077 14.3203 7.15967C14.3203 3.21162 11.1082 -0.000489516 7.16016 -0.000489861C3.21211 -0.000490206 1.74354e-08 3.21162 -3.27714e-07 7.15967C-6.72862e-07 11.1077 3.21211 14.3198 7.16016 14.3198ZM7.16016 0.89453C10.6148 0.89453 13.4253 3.705 13.4253 7.15967C13.4253 10.6143 10.6148 13.4248 7.16016 13.4248C3.70549 13.4248 0.895019 10.6143 0.895019 7.15967C0.89502 3.705 3.70549 0.894529 7.16016 0.89453ZM4.15871 7.47606C3.98384 7.30119 3.98384 7.01803 4.15871 6.84328L6.39626 4.60573C6.48363 4.51835 6.5982 4.47461 6.71265 4.47461C6.8271 4.47461 6.94166 4.51835 7.02904 4.60573C7.2039 4.78059 7.2039 5.06376 7.02904 5.23851L5.55539 6.71216L9.84522 6.71216C10.0924 6.71216 10.2927 6.91231 10.2927 7.15967C10.2927 7.40703 10.0924 7.60718 9.84521 7.60718L5.55539 7.60718L7.02904 9.08083C7.2039 9.25569 7.2039 9.53885 7.02904 9.71361C6.85417 9.88836 6.57101 9.88847 6.39626 9.71361L4.15871 7.47606Z" fill="#183E40"/></svg></button>',
        nextArrow:
            '<button type="button" class="slick-next"><svg class="icon-right-cirle-arrow" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.16 0C3.21204 0 0 3.21204 0 7.16C0 11.108 3.21204 14.32 7.16 14.32C11.108 14.32 14.32 11.108 14.32 7.16C14.32 3.21204 11.108 0 7.16 0ZM7.16 13.425C3.70541 13.425 0.895 10.6146 0.895 7.16C0.895 3.70541 3.70541 0.895 7.16 0.895C10.6146 0.895 13.425 3.70541 13.425 7.16C13.425 10.6146 10.6146 13.425 7.16 13.425ZM10.1614 6.84362C10.3362 7.01848 10.3362 7.30163 10.1614 7.47638L7.92388 9.71388C7.83651 9.80126 7.72195 9.845 7.6075 9.845C7.49305 9.845 7.37849 9.80126 7.29112 9.71388C7.11626 9.53902 7.11626 9.25587 7.29112 9.08112L8.76474 7.6075H4.475C4.22787 7.6075 4.0275 7.40736 4.0275 7.16C4.0275 6.91264 4.22787 6.7125 4.475 6.7125H8.76474L7.29112 5.23888C7.11626 5.06402 7.11626 4.78087 7.29112 4.60612C7.46598 4.43137 7.74913 4.43126 7.92388 4.60612L10.1614 6.84362Z" fill="#183E40"/></svg></button>',
        responsive: [
            {
                breakpoint: 1250,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 6,
                },
            },
            {
                breakpoint: 767,
                settings: "unslick",
            },
        ],
    },
    productPageFilterCrownSliderSettings: {
        dots: false,
        speed: 300,
        infinite: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        prevArrow:
            '<button type="button" class="slick-prev"><svg class="icon-left-cirle-arrow" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.16016 14.3198C11.1082 14.3198 14.3203 11.1077 14.3203 7.15967C14.3203 3.21162 11.1082 -0.000489516 7.16016 -0.000489861C3.21211 -0.000490206 1.74354e-08 3.21162 -3.27714e-07 7.15967C-6.72862e-07 11.1077 3.21211 14.3198 7.16016 14.3198ZM7.16016 0.89453C10.6148 0.89453 13.4253 3.705 13.4253 7.15967C13.4253 10.6143 10.6148 13.4248 7.16016 13.4248C3.70549 13.4248 0.895019 10.6143 0.895019 7.15967C0.89502 3.705 3.70549 0.894529 7.16016 0.89453ZM4.15871 7.47606C3.98384 7.30119 3.98384 7.01803 4.15871 6.84328L6.39626 4.60573C6.48363 4.51835 6.5982 4.47461 6.71265 4.47461C6.8271 4.47461 6.94166 4.51835 7.02904 4.60573C7.2039 4.78059 7.2039 5.06376 7.02904 5.23851L5.55539 6.71216L9.84522 6.71216C10.0924 6.71216 10.2927 6.91231 10.2927 7.15967C10.2927 7.40703 10.0924 7.60718 9.84521 7.60718L5.55539 7.60718L7.02904 9.08083C7.2039 9.25569 7.2039 9.53885 7.02904 9.71361C6.85417 9.88836 6.57101 9.88847 6.39626 9.71361L4.15871 7.47606Z" fill="#183E40"/></svg></button>',
        nextArrow:
            '<button type="button" class="slick-next"><svg class="icon-right-cirle-arrow" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.16 0C3.21204 0 0 3.21204 0 7.16C0 11.108 3.21204 14.32 7.16 14.32C11.108 14.32 14.32 11.108 14.32 7.16C14.32 3.21204 11.108 0 7.16 0ZM7.16 13.425C3.70541 13.425 0.895 10.6146 0.895 7.16C0.895 3.70541 3.70541 0.895 7.16 0.895C10.6146 0.895 13.425 3.70541 13.425 7.16C13.425 10.6146 10.6146 13.425 7.16 13.425ZM10.1614 6.84362C10.3362 7.01848 10.3362 7.30163 10.1614 7.47638L7.92388 9.71388C7.83651 9.80126 7.72195 9.845 7.6075 9.845C7.49305 9.845 7.37849 9.80126 7.29112 9.71388C7.11626 9.53902 7.11626 9.25587 7.29112 9.08112L8.76474 7.6075H4.475C4.22787 7.6075 4.0275 7.40736 4.0275 7.16C4.0275 6.91264 4.22787 6.7125 4.475 6.7125H8.76474L7.29112 5.23888C7.11626 5.06402 7.11626 4.78087 7.29112 4.60612C7.46598 4.43137 7.74913 4.43126 7.92388 4.60612L10.1614 6.84362Z" fill="#183E40"/></svg></button>',
        responsive: [
            {
                breakpoint: 1250,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 6,
                },
            },
            {
                breakpoint: 767,
                settings: "unslick",
            },
        ],
    },
    productPageFilterShankSliderSettings: {
        dots: false,
        speed: 300,
        infinite: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        prevArrow:
            '<button type="button" class="slick-prev"><svg class="icon-left-cirle-arrow" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.16016 14.3198C11.1082 14.3198 14.3203 11.1077 14.3203 7.15967C14.3203 3.21162 11.1082 -0.000489516 7.16016 -0.000489861C3.21211 -0.000490206 1.74354e-08 3.21162 -3.27714e-07 7.15967C-6.72862e-07 11.1077 3.21211 14.3198 7.16016 14.3198ZM7.16016 0.89453C10.6148 0.89453 13.4253 3.705 13.4253 7.15967C13.4253 10.6143 10.6148 13.4248 7.16016 13.4248C3.70549 13.4248 0.895019 10.6143 0.895019 7.15967C0.89502 3.705 3.70549 0.894529 7.16016 0.89453ZM4.15871 7.47606C3.98384 7.30119 3.98384 7.01803 4.15871 6.84328L6.39626 4.60573C6.48363 4.51835 6.5982 4.47461 6.71265 4.47461C6.8271 4.47461 6.94166 4.51835 7.02904 4.60573C7.2039 4.78059 7.2039 5.06376 7.02904 5.23851L5.55539 6.71216L9.84522 6.71216C10.0924 6.71216 10.2927 6.91231 10.2927 7.15967C10.2927 7.40703 10.0924 7.60718 9.84521 7.60718L5.55539 7.60718L7.02904 9.08083C7.2039 9.25569 7.2039 9.53885 7.02904 9.71361C6.85417 9.88836 6.57101 9.88847 6.39626 9.71361L4.15871 7.47606Z" fill="#183E40"/></svg></button>',
        nextArrow:
            '<button type="button" class="slick-next"><svg class="icon-right-cirle-arrow" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.16 0C3.21204 0 0 3.21204 0 7.16C0 11.108 3.21204 14.32 7.16 14.32C11.108 14.32 14.32 11.108 14.32 7.16C14.32 3.21204 11.108 0 7.16 0ZM7.16 13.425C3.70541 13.425 0.895 10.6146 0.895 7.16C0.895 3.70541 3.70541 0.895 7.16 0.895C10.6146 0.895 13.425 3.70541 13.425 7.16C13.425 10.6146 10.6146 13.425 7.16 13.425ZM10.1614 6.84362C10.3362 7.01848 10.3362 7.30163 10.1614 7.47638L7.92388 9.71388C7.83651 9.80126 7.72195 9.845 7.6075 9.845C7.49305 9.845 7.37849 9.80126 7.29112 9.71388C7.11626 9.53902 7.11626 9.25587 7.29112 9.08112L8.76474 7.6075H4.475C4.22787 7.6075 4.0275 7.40736 4.0275 7.16C4.0275 6.91264 4.22787 6.7125 4.475 6.7125H8.76474L7.29112 5.23888C7.11626 5.06402 7.11626 4.78087 7.29112 4.60612C7.46598 4.43137 7.74913 4.43126 7.92388 4.60612L10.1614 6.84362Z" fill="#183E40"/></svg></button>',
        responsive: [
            {
                breakpoint: 1250,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 6,
                },
            },
            {
                breakpoint: 767,
                settings: "unslick",
            },
        ],
    },
    mainProductPageImagesSliderSettings: {
        speed: 300,
        dots: false,
        swipe: false,
        touchMove: true,
        vertical: false,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: false,
        verticalSwiping: false,
        fade: false,
        appendDots: $('.product-page--images-thumbnail'),
        asNavFor: '.product-page--images-thumbnail-slider',
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    swipe: true,
                    dots: true
                }
            }
        ]
    },
    productPageImagesThumbnailSliderSettings: {
        speed: 300,
        arrow: true,
        vertical: true,
        infinite: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        focusOnSelect: true,
        swipeToSlide: true,
        verticalSwiping: true,
        asNavFor: '.setting-product-page-images-main-section-slider-for',
        prevArrow: '<button type="button" class="slick-prev"><svg class="icon-left-cirle-arrow" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.16016 14.3198C11.1082 14.3198 14.3203 11.1077 14.3203 7.15967C14.3203 3.21162 11.1082 -0.000489516 7.16016 -0.000489861C3.21211 -0.000490206 1.74354e-08 3.21162 -3.27714e-07 7.15967C-6.72862e-07 11.1077 3.21211 14.3198 7.16016 14.3198ZM7.16016 0.89453C10.6148 0.89453 13.4253 3.705 13.4253 7.15967C13.4253 10.6143 10.6148 13.4248 7.16016 13.4248C3.70549 13.4248 0.895019 10.6143 0.895019 7.15967C0.89502 3.705 3.70549 0.894529 7.16016 0.89453ZM4.15871 7.47606C3.98384 7.30119 3.98384 7.01803 4.15871 6.84328L6.39626 4.60573C6.48363 4.51835 6.5982 4.47461 6.71265 4.47461C6.8271 4.47461 6.94166 4.51835 7.02904 4.60573C7.2039 4.78059 7.2039 5.06376 7.02904 5.23851L5.55539 6.71216L9.84522 6.71216C10.0924 6.71216 10.2927 6.91231 10.2927 7.15967C10.2927 7.40703 10.0924 7.60718 9.84521 7.60718L5.55539 7.60718L7.02904 9.08083C7.2039 9.25569 7.2039 9.53885 7.02904 9.71361C6.85417 9.88836 6.57101 9.88847 6.39626 9.71361L4.15871 7.47606Z" fill="#183E40"/></svg></button>',
        nextArrow: '<button type="button" class="slick-next"><svg class="icon-right-cirle-arrow" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.16 0C3.21204 0 0 3.21204 0 7.16C0 11.108 3.21204 14.32 7.16 14.32C11.108 14.32 14.32 11.108 14.32 7.16C14.32 3.21204 11.108 0 7.16 0ZM7.16 13.425C3.70541 13.425 0.895 10.6146 0.895 7.16C0.895 3.70541 3.70541 0.895 7.16 0.895C10.6146 0.895 13.425 3.70541 13.425 7.16C13.425 10.6146 10.6146 13.425 7.16 13.425ZM10.1614 6.84362C10.3362 7.01848 10.3362 7.30163 10.1614 7.47638L7.92388 9.71388C7.83651 9.80126 7.72195 9.845 7.6075 9.845C7.49305 9.845 7.37849 9.80126 7.29112 9.71388C7.11626 9.53902 7.11626 9.25587 7.29112 9.08112L8.76474 7.6075H4.475C4.22787 7.6075 4.0275 7.40736 4.0275 7.16C4.0275 6.91264 4.22787 6.7125 4.475 6.7125H8.76474L7.29112 5.23888C7.11626 5.06402 7.11626 4.78087 7.29112 4.60612C7.46598 4.43137 7.74913 4.43126 7.92388 4.60612L10.1614 6.84362Z" fill="#183E40"/></svg></button>',
        responsive: [
            {
                breakpoint: 991,
                settings: "unslick",
            }
        ]
    }
};

const engraving_images = {
    yellow: "https://cdn.shopify.com/s/files/1/0630/0300/1005/files/yellow-engrave.png?v=1728023014",
    white: "https://cdn.shopify.com/s/files/1/0630/0300/1005/files/white-engrave.png?v=1728023014",
    rose: "https://cdn.shopify.com/s/files/1/0630/0300/1005/files/red-engrave.png?v=1728023014",
    platinum: "https://cdn.shopify.com/s/files/1/0630/0300/1005/files/white-engrave.png?v=1728023014",
};

$(".product-page--images-thumbnail-slider").slick(slickSettings.productPageImagesThumbnailSliderSettings);
$(".setting-product-page-images-main-section-slider-for").slick(slickSettings.mainProductPageImagesSliderSettings);

String.prototype.upperCase = function () {
    return this.split(" ")
        .map((word) =>
            word.length === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)
        )
        .join(" ");
};

const view3DElement = document.querySelector('.thumbnail-image.setting-thumbnail-image.image-3d[data-type="3D_view"]') || null;
let ajaxCallDiamondListRunning = "No",
    myCustomController = null,
    isQueryParams = "No",
    totalResultIndex = 0,
    totalCount = 0,
    isFirstTime3DView = false;
window.RING_CREATOR_PDP = (function () {
    return {
        config: {},
        fetchData: async function (data) {
            myCustomController = new AbortController();
            const myCustomSignal = myCustomController.signal;
            return await fetch(`${baseAppProxy}/frontend.php`, {
                signal: myCustomSignal,
                method: "POST",
                body: data,
            })
                .then((response) => response.json())
                .then((result) => result)
                .catch((error) => error);
        },
        fetchProductRelatedAllData: async function () {
            try {
                var formData = new FormData();
                formData.append("action", "fetch_all_data_for_webgi");
                formData.append("shop", Shopify.shop);
                formData.append("product_title", configuratorName);
                formData.append("product_handle", document.getElementById("setting_hdn_prod_handle").value);

                const webGiProdInfo = await this.fetchData(formData);
                if (webGiProdInfo?.SUCCESS === "TRUE") {
                    const webGiProdInfoData = webGiProdInfo?.DATA;
                    this.initEventOptionHTML(webGiProdInfoData?.option_data);
                    if (
                        webGiProdInfoData?.head_glb_url?.length > 0 &&
                        webGiProdInfoData?.shank_glb_url?.length > 0
                    ) {
                        view3DElement && (view3DElement.style.display = "block");
                        this.config.headGlbUrl = webGiProdInfoData?.head_glb_url;
                        this.config.shankGlbUrl = webGiProdInfoData?.shank_glb_url;
                    }
                }
                if (RING_CREATOR_PDP.getUrlParameter("stone-stock") === undefined) {
                    document.getElementById("custom-page-loader").style.display = "none";
                    document
                        .getElementById("product-page-filter-setting-options")
                        .classList.remove("skelaton");
                    //RAJAN NEEDS TO HIDE SKELETON FROM HERE
                }
            } catch (error) {
                console.log({ error });
            }
        },
        fetchProductRelatedAllDataBasedOnAttr: async function (
            selectedAttributeData,
            selectedItemObj
        ) {
            try {
                var formData = new FormData();
                formData.append("action", "fetch_all_data_for_webgi_based_on_attr");
                formData.append("shop", Shopify.shop);
                formData.append("product_title", configuratorName);
                formData.append(
                    "attribute_info",
                    JSON.stringify(selectedAttributeData)
                );
                formData.append(
                    "selected_attribute_info",
                    JSON.stringify(selectedItemObj)
                );
                return await this.fetchData(formData);
            } catch (error) {
                console.log({ error });
            }
        },
        fetchStoneProductByStockNumber: async function () {
            try {
                let stockNumber = this.getUrlParameter("stone-stock");
                if (stockNumber?.length > 0) {
                    var formData = new FormData();
                    formData.append("action", "getProductByStockNumber");
                    formData.append("shop", Shopify.shop);
                    formData.append("stock_nums", stockNumber);

                    const getProdInfo = await this.fetchData(formData);
                    if (Object.keys(getProdInfo?.data)?.length > 0) {
                        const getProdInfoData = getProdInfo?.data;
                        RING_CREATOR_PDP.config.selectStoneProduct = getProdInfoData;

                        const errorSrc = `this.src='${baseAppProxy}/images/no-image.png'`;
                        if (document.getElementById("review-stone-image")) {
                            const reviewStoneImageElement = document.getElementById("review-stone-image");
                            reviewStoneImageElement.style.display = "none";
                            if (getProdInfoData?.image_url) {
                                reviewStoneImageElement.src = getProdInfoData?.image_url;
                                reviewStoneImageElement.style.display = "";
                                reviewStoneImageElement.setAttribute('onerror', errorSrc);
                            }
                        }

                        if (document.querySelector("[data-selected-stone-icon]")) {
                            document.querySelector(
                                "[data-selected-stone-icon]"
                            ).innerHTML = `<img src="${getProdInfoData?.image_url}" width="60px" alt="Stone Image">`;
                        }

                        let discountedProductPrice = Number(
                            getProdInfoData?.total_sales_price
                        );
                        if (productDiscount > 0) {
                            const priceDiscount =
                                (Number(getProdInfoData?.total_sales_price) * productDiscount) /
                                100;
                            discountedProductPrice =
                                Number(getProdInfoData?.total_sales_price) - priceDiscount;
                        }

                        document.querySelector("[data-stone-product-title]") &&
                            (document.querySelector("[data-stone-product-title]").innerText =
                                getProdInfoData?.long_title);
                        document.querySelector("[data-stone-product-price]") &&
                            (document.querySelector(
                                "[data-stone-product-price]"
                            ).innerHTML = `- ${RING_CREATOR_PDP.formatMoney(
                                discountedProductPrice * 100
                            )}`);
                        if (getProdInfoData?.image_url) {
                            document.querySelector("[data-diamond-setting-section]") &&
                                (document.querySelector(
                                    "[data-diamond-setting-section]"
                                ).innerHTML = `<img src="${getProdInfoData?.image_url}" alt="Stone image" width="85" height="85" loading="eager">`);
                        }

                        if (RING_CREATOR_PDP.getUrlParameter("review") != undefined) {
                            document.querySelector(
                                "[data-review-stone-product-title]"
                            ).innerText = getProdInfoData?.long_title;
                            const reviewStonePriceElement = document.querySelector(
                                "[data-review-stone-price]"
                            );

                            reviewStonePriceElement.innerHTML = RING_CREATOR_PDP.formatMoney(
                                discountedProductPrice * 100
                            );
                            document.querySelector("[data-review-total-price]").innerHTML =
                                RING_CREATOR_PDP.formatMoney(
                                    (Number(
                                        reviewStonePriceElement.dataset.ringPrice
                                            .replace(/,/g, "")
                                            .trim()
                                    ) +
                                        discountedProductPrice) *
                                    100
                                );

                            let stoneDetailHTML = "";
                            getProdInfoData?.cut && (stoneDetailHTML += `<span>${getProdInfoData?.cut} cut</span><span> • </span>`);
                            getProdInfoData?.color && (stoneDetailHTML += `<span>${getProdInfoData?.color} color</span><span> • </span>`);
                            getProdInfoData?.clarity && (stoneDetailHTML += `<span>${getProdInfoData?.clarity} clarity</span><span> • </span>`);
                            getProdInfoData?.lab && (stoneDetailHTML += `<span>${getProdInfoData?.lab} certified</span>`);
                            document.querySelector("[data-review-stone-detail]").innerHTML = stoneDetailHTML;
                            document.querySelector("[data-review-stone-product-carat]").innerText = `The total diamond carat weight of your ring is ${getProdInfoData?.size} ct.`;
                            if (RING_CREATOR_PDP.getCookie("engravingText")?.length > 0) {
                                // && RING_CREATOR_PDP.getCookie('engravingFontFamily')?.length > 0
                                const reviewInscriptionTextElement = document.querySelector("[data-review-inscription-text]");
                                reviewInscriptionTextElement.innerText = RING_CREATOR_PDP.getCookie("engravingText");
                                reviewInscriptionTextElement.classList = "";
                                reviewInscriptionTextElement.className = `product-page--engraving-preview-text ${RING_CREATOR_PDP.getCookie("engravingFontFamily")}`;
                            }
                        }
                    }
                    document.getElementById("custom-page-loader").style.display = "none";
                    document.getElementById("product-page-filter-setting-options") && document.getElementById("product-page-filter-setting-options").classList.remove("skelaton");
                }
            } catch (error) {
                console.log({ error });
            }
        },
        initEventOptionHTML: async function (optionsData) {
            const mainOptions = Object.keys(optionsData)?.length > 0 ? Object.keys(optionsData) : [];
            const productPageFilterSettingOptionsElement = document.getElementById("product-page-filter-setting-options");

            let optionHTML = "", optionDisabled = "";
            mainOptions.forEach((mainOption, index) => {
                const subArray = optionsData[mainOption];
                const { main_option_title, main_option_slug, main_option_order, group_name } = subArray[0];
                const defaultSubOptionData = subArray.find((subObject) => subObject?.is_default_value === "1");
                const defaultSubOptionValue = defaultSubOptionData?.sub_option_title;
                const defaultSubOptionSlug = defaultSubOptionData?.sub_option_slug;

                if (RING_CREATOR_PDP.getUrlParameter('stone-stock') != undefined && main_option_slug == 'shape') {
                    optionDisabled = ' disabled';
                }

                if (defaultSubOptionData?.main_option_slug == "metal" && document.querySelectorAll("[data-engraving-inscription]")?.length) {
                    let selectedMetalColorValue = defaultSubOptionData?.sub_option_title.replace(/14k|18k|14K|18K|Gold|gold/g, "").trim().toLowerCase();
                    let metalHandle = selectedMetalColorValue;
                    if (selectedMetalColorValue.includes("platinum")) {
                        metalHandle = "white";
                    } else if (selectedMetalColorValue.includes("/")) {
                        metalHandle = selectedMetalColorValue.split("/")[0];
                    }
                    engraving_images[metalHandle] != undefined && Array.from(document.querySelectorAll("[data-engraving-inscription]")).forEach(e => e.setAttribute("src", engraving_images[metalHandle]));
                }

                RING_CREATOR_PDP.config[defaultSubOptionData?.group_name] = defaultSubOptionData?.sub_option_title;
                if (document.querySelector(`.product-page--selected-setting_value[data-review-stone-${defaultSubOptionData?.main_option_slug}]`)) {
                    const stringComma = mainOptions?.length - 1 == index ? "" : ",";
                    document.querySelector(`.product-page--selected-setting_value[data-review-stone-${defaultSubOptionData?.main_option_slug}]`).innerText = defaultSubOptionData?.sub_option_title?.length > 0 ? `${defaultSubOptionData?.sub_option_title}${stringComma}` : `-${stringComma}`;
                }
                const variantOptionHtml = subArray
                    .map((subObject) => {
                        const { main_option_slug, sub_option_title, sub_option_slug, sub_option_icon, is_default_value, group_name, display_option } = subObject;
                        const errorSrc = `this.src='${baseAppProxy}/images/no-image.png'`;
                        const activeClass = is_default_value === "1" ? "product-page--filter--active" : "";
                        return `<div class="product-page--filter-value-item ${activeClass} ${sub_option_slug.replace("14k-", "").replace("18k-", "")}" data-main-slug="${main_option_slug}" title="${sub_option_title}" data-group-name="${group_name}" data-name="${main_option_title}" data-value="${sub_option_title}" data-slug="${sub_option_slug}">
                            <div class="product-page--filter-${mainOption}-value">
                                ${display_option == "circle_icon" ? `<img src="${sub_option_icon}" onerror="${errorSrc}" width="100%" height="100%" loading="eager">` : `<span>${sub_option_title}</span>`}
                            </div>
                        </div>`;
                    }).join("");

                // line item property field
                optionHTML += `<input type="hidden" class="lineitem_prop" data-main-option-order="${main_option_order}" data-main-option-group="${group_name}" data-name="${main_option_title}" name="attributes[${main_option_title}]" data-main-option-slug="${main_option_slug}" data-sub-option-slug="${defaultSubOptionSlug}" value="${defaultSubOptionValue}">`;
                optionHTML += `<div class="product-page--filter-item product-page--filter-item-${mainOption}">
                    <div class="product-page--filter-item-label-wrapper">
                        <div class="product-page--filter-label">${main_option_title}:</div>
                        <div class="product-page--filter-selected-value" data-filter-selected-${main_option_slug}-value>${defaultSubOptionValue}</div>
                    </div>
                    <div class="product-page--filter-values product-page--filter-${mainOption}-slider variant_option${optionDisabled}" data-attr_name="${main_option_title}" data-attr_group_name="${group_name}" data-attr_slug="${main_option_slug}">${variantOptionHtml}</div>
                </div>`;
            });
            productPageFilterSettingOptionsElement && (productPageFilterSettingOptionsElement.innerHTML = optionHTML);

            mainOptions.forEach((mainOption) => $(`.product-page--filter-${mainOption}-slider`).slick(slickSettings[`productPageFilter${mainOption.upperCase()}SliderSettings`]));
            this.initEventsOnChanged();

            RING_CREATOR_PDP.conObjToArrElements(".product-page--filter--active").forEach(function (element) {
                if ($(`.product-page--filter-${element.dataset.mainSlug}-slider`)) {
                    const slidesToShow = Number($(`.product-page--filter-${element.dataset.mainSlug}-slider`).slick("slickGetOption", "slidesToShow"));
                    const slickIndex = Number(element.dataset.slickIndex) + 1;
                    $(`.product-page--filter-${element.dataset.mainSlug}-slider`).slick("slickGoTo", Math.round(slickIndex - slidesToShow));
                }
            });
        },
        initEventImagesHTML: async function (imagesData) {
            const productPageImagesThumbnailSliderElement = document.querySelector(".product-page--images-thumbnail-slider");
            const prodImageArr = imagesData || [];
            productPageImagesThumbnailSliderElement.innerHTML = "";
            $(".product-page--images-thumbnail-slider").slick("unslick");
            const prodImageArrThumb = prodImageArr.map((item, index) => {
                return `<div class="thumbnail-image setting-thumbnail-image${index == 0 ? " thumbnail-image--active" : ""}" data-type="image" data-image-src="${item?.node?.url}">
                    <img src="${item?.node?.url}&width=101" width="101" height="101" loading="eager">
                </div>`;
            }).join("");
            productPageImagesThumbnailSliderElement.innerHTML = prodImageArrThumb;
            $(".product-page--images-thumbnail-slider").slick(slickSettings.productPageImagesThumbnailSliderSettings);

            const settingProductPageImagesMainSectionElement = document.getElementById("setting-product-page-images-main-section");
            settingProductPageImagesMainSectionElement.innerHTML = "";
            $(".setting-product-page-images-main-section-slider-for").slick("unslick");
            const mainProdImageArr = prodImageArr.map((item, index) => {
                return `<img src="${item?.node?.url}" width="100%" height="100%" loading="eager">`;
            }).join("");
            settingProductPageImagesMainSectionElement.innerHTML = mainProdImageArr;
            // if (prodImageArr[0]) {
            //     settingProductPageImagesMainSectionElement.innerHTML = `<img src="${prodImageArr[0]?.node?.url}" width="100%" height="100%" loading="eager">`;
            // }
            $(".setting-product-page-images-main-section-slider-for").slick(slickSettings.mainProductPageImagesSliderSettings);
            await this.initEventImagesOnClick();
        },
        initEventsOnChanged: async function () {
            const productPageFilterValueItemElement = this.conObjToArrElements(
                ".product-page--filter-value-item"
            );
            if (productPageFilterValueItemElement?.length > 0) {
                productPageFilterValueItemElement.forEach((item) => {
                    item.addEventListener("click", async function (e) {
                        const {
                            name: current_name,
                            value: current_value,
                            slug: current_value_slug,
                        } = this.dataset;
                        const {
                            mainOptionSlug: current_main_option_slug,
                            mainOptionOrder: current_main_option_order,
                        } = document.querySelector(
                            `.lineitem_prop[data-name="${current_name}"]`
                        ).dataset;

                        RING_CREATOR_PDP.conObjToArrElements(
                            `.product-page--filter-value-item[data-name="${current_name}"]`
                        ).forEach((e) =>
                            e.classList.remove("product-page--filter--active")
                        );
                        this.classList.add("product-page--filter--active");

                        document.querySelector(
                            `.product-page--filter-selected-value[data-filter-selected-${current_main_option_slug}-value]`
                        ).innerText = current_value;
                        document.querySelector(
                            `.lineitem_prop[data-name="${current_name}"]`
                        ).value = current_value;
                        document
                            .querySelector(`.lineitem_prop[data-name="${current_name}"]`)
                            .setAttribute("data-sub-option-slug", current_value_slug);

                        let lineItemAttrObj = {};
                        let parentSlugArray = [];
                        const lineItemPropElements = RING_CREATOR_PDP.conObjToArrElements(
                            '.lineitem_prop[name*="attributes"]'
                        );
                        lineItemPropElements.forEach((lineitemPropElement) => {
                            const { mainOptionSlug, mainOptionOrder } =
                                lineitemPropElement.dataset;
                            lineItemAttrObj[mainOptionSlug] = lineitemPropElement.value;
                            if (Number(mainOptionOrder) < Number(current_main_option_order)) {
                                parentSlugArray.push(mainOptionSlug);
                            }
                        });

                        var commaSeparatedValues = [];
                        RING_CREATOR_PDP.conObjToArrElements(
                            `.variant_option[data-attr_name="${current_name}"]`
                        ).forEach((item) => {
                            Array.from(
                                item.querySelectorAll(".product-page--filter-value-item")
                            ).filter((item) => {
                                commaSeparatedValues.push(item.dataset.value);
                            });
                        });
                        var commaSeparatedValueString = commaSeparatedValues.join(",");

                        let selectedItemObj = {};
                        if (!selectedItemObj[current_main_option_slug]) {
                            selectedItemObj[current_main_option_slug] = {};
                        }
                        selectedItemObj[current_main_option_slug]["selected_val"] =
                            current_value;
                        selectedItemObj[current_main_option_slug]["all_val"] =
                            commaSeparatedValueString;
                        selectedItemObj[current_main_option_slug]["parent_slugs"] =
                            parentSlugArray;
                        // view3DElement && (view3DElement.style.display = 'none');
                        const webGiProdInfo =
                            await RING_CREATOR_PDP.fetchProductRelatedAllDataBasedOnAttr(
                                lineItemAttrObj,
                                selectedItemObj
                            );
                        if (webGiProdInfo?.SUCCESS == "TRUE") {
                            const webGiProdInfoData = webGiProdInfo?.DATA;
                            await RING_CREATOR_PDP.initEventOptionHTML(
                                webGiProdInfoData?.option_data
                            );
                            await RING_CREATOR_PDP.initEventImagesHTML(
                                webGiProdInfoData?.product_images
                            );

                            if (
                                webGiProdInfoData?.head_glb_url?.length > 0 &&
                                webGiProdInfoData?.shank_glb_url?.length > 0
                            ) {
                                // view3DElement && (view3DElement.style.display = 'block');
                                RING_CREATOR_PDP.config.headGlbUrl =
                                    webGiProdInfoData?.head_glb_url;
                                RING_CREATOR_PDP.config.shankGlbUrl =
                                    webGiProdInfoData?.shank_glb_url;
                            }

                            if (document.querySelector(".thumbnail-image.setting-thumbnail-image.thumbnail-image--active")?.dataset?.type == "3D_view") {
                                await RING_CREATOR_PDP.handleThreeDPart(webGiProdInfoData.head_glb_url, webGiProdInfoData.shank_glb_url, true);
                            }
                            RING_CREATOR_PDP.conObjToArrElements(
                                ".settings-product-page--wrapper h1.product-page--title"
                            ).forEach(
                                (e) => (e.innerText = webGiProdInfoData?.product_title)
                            );
                            document.getElementById("setting_hdn_prod_title").value =
                                webGiProdInfoData?.product_title;
                            document.getElementById("setting_hdn_prod_id").value =
                                webGiProdInfoData?.product_id;
                            document.getElementById("setting_hdn_prod_handle").value =
                                webGiProdInfoData?.product_handle;
                            document.querySelector("[data-setting-description]") &&
                                (document.querySelector(
                                    "[data-setting-description]"
                                ).innerText = webGiProdInfoData?.product_description);
                            document.getElementById("setting_hdn_prod_var_id").value =
                                webGiProdInfoData?.product_variant_id;

                            if (
                                document.querySelectorAll("wishlist-button-block")?.length > 0
                            ) {
                                document
                                    .querySelectorAll("wishlist-button-block")
                                    .forEach(
                                        (e) =>
                                        (e.dataset.productHandle =
                                            webGiProdInfoData?.product_handle)
                                    );
                            }

                            let discountedProductPrice =
                                webGiProdInfoData?.product_variant_price;
                            if (productDiscount > 0) {
                                const priceDiscount =
                                    (Number(webGiProdInfoData?.product_variant_price) *
                                        productDiscount) /
                                    100;
                                discountedProductPrice =
                                    Number(webGiProdInfoData?.product_variant_price) -
                                    priceDiscount;
                            }

                            document.getElementById("setting_hdn_prod_var_price").value =
                                discountedProductPrice;
                            Array.from(
                                document.querySelectorAll("[data-setting-ring-price]")
                            ).forEach(
                                (e) =>
                                (e.innerHTML = RING_CREATOR_PDP.formatMoney(
                                    Number(discountedProductPrice) * 100
                                ))
                            );
                            RING_CREATOR_PDP.conObjToArrElements(
                                "[data-popup-product-title]"
                            ).forEach(
                                (e) => (e.innerText = webGiProdInfoData?.product_title)
                            );
                            RING_CREATOR_PDP.conObjToArrElements(
                                "[data-popup-product-image]"
                            ).forEach(
                                (e) => (e.src = webGiProdInfoData?.product_images[0]?.node?.url)
                            );

                            let estimatedShipDate = "N/A";
                            if (webGiProdInfoData?.product_tags?.length > 0) {
                                if (
                                    webGiProdInfoData?.product_tags.includes("Omega Express") ==
                                    true
                                ) {
                                    estimatedShipDate = "2nd Business Day";
                                } else if (
                                    webGiProdInfoData?.product_tags.includes("Omega Ready") ==
                                    true
                                ) {
                                    estimatedShipDate = "3-5 Business Days";
                                } else if (
                                    webGiProdInfoData?.product_tags.includes("Omega Custom") ==
                                    true
                                ) {
                                    estimatedShipDate = "8-10 Business Days";
                                } else if (
                                    webGiProdInfoData?.product_tags.includes("Omega Custom2") ==
                                    true
                                ) {
                                    estimatedShipDate = "10-12 Business Days";
                                } else if (
                                    webGiProdInfoData?.product_tags.includes("Omega Custom3") ==
                                    true
                                ) {
                                    estimatedShipDate = "12-15 Business Days";
                                } else if (
                                    webGiProdInfoData?.product_tags.includes("Omega Custom4") ==
                                    true
                                ) {
                                    estimatedShipDate = "15-18 Business Days";
                                }
                            }
                            RING_CREATOR_PDP.conObjToArrElements("[data-estimated-ship-date]").forEach((e) => (e.innerText = estimatedShipDate));

                            let newURL = "/products/" + webGiProdInfoData?.product_handle + "?variant=" + webGiProdInfoData?.product_variant_id;
                            if (RING_CREATOR_PDP.getUrlParameter('stone-stock') != undefined) {
                                newURL += `&stone-stock=${RING_CREATOR_PDP.getUrlParameter('stone-stock')}`;
                            }
                            if (RING_CREATOR_PDP.getUrlParameter('steps') != undefined) {
                                newURL += `&steps=${RING_CREATOR_PDP.getUrlParameter('steps')}`;
                            }
                            if (RING_CREATOR_PDP.getUrlParameter('review') != undefined) {
                                newURL += `&review=${RING_CREATOR_PDP.getUrlParameter('review')}`;
                            }
                            window.history.pushState({}, "", newURL);
                        } else {
                            console.log("Data not found based on attribute");
                        }
                    });
                });
            }
        },
        formatMoney: function (cents, format) {
            if (typeof cents == "string") {
                cents = cents.replace(".", "");
            }
            var value = "";
            var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
            var formatString = format || moneyFormat;

            function defaultOption(opt, def) {
                return typeof opt == "undefined" ? def : opt;
            }

            function formatWithDelimiters(number, precision, thousands, decimal) {
                precision = defaultOption(precision, 2);
                thousands = defaultOption(thousands, ",");
                decimal = defaultOption(decimal, ".");
                if (isNaN(number) || number == null) {
                    return 0;
                }
                number = (number / 100.0).toFixed(precision);
                var parts = number.split("."),
                    dollars = parts[0].replace(
                        /(\d)(?=(\d\d\d)+(?!\d))/g,
                        "$1" + thousands
                    ),
                    cents = parts[1] ? decimal + parts[1] : "";
                return dollars + cents;
            }
            switch (formatString.match(placeholderRegex)[1]) {
                case "amount":
                    value = formatWithDelimiters(cents, 2);
                    break;
                case "amount_no_decimals":
                    value = formatWithDelimiters(cents, 0);
                    break;
                case "amount_with_comma_separator":
                    value = formatWithDelimiters(cents, 2, ".", ",");
                    break;
                case "amount_no_decimals_with_comma_separator":
                    value = formatWithDelimiters(cents, 0, ".", ",");
                    break;
            }
            return formatString.replace(placeholderRegex, value);
        },
        conObjToArrElements: function (element) {
            return Array.prototype.slice.call(document.querySelectorAll(element));
        },
        getUrlParameter: function (sParam) {
            var sPageURL = window.location.search.substring(1), sURLVariables = sPageURL.split("&"), sParameterName, i;
            for (i = 0; i < sURLVariables.length; i++) {
                sParameterName = sURLVariables[i].split("=");
                if (sParameterName[0] === sParam) {
                    return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
                }
            }
        },
        initEventImagesOnClick: async function () {
            async function loadOnClickForImages(viewType) {
                const settingProductPageImagesMainSectionElement = document.getElementById("setting-product-page-images-main-section");
                // settingProductPageImagesMainSectionElement.innerHTML = "";
                        settingProductPageImagesMainSectionElement.style.display = "none";

                const webglSettingCanvasElement = document.getElementById("webgl_setting_canvas");
                        webglSettingCanvasElement.innerHTML = "";
                        webglSettingCanvasElement.style.display = "none";
                if (viewType == "3D_view") {
                            webglSettingCanvasElement.style.display = "block";
                    await RING_CREATOR_PDP.handleThreeDPart(RING_CREATOR_PDP.config.headGlbUrl, RING_CREATOR_PDP.config.shankGlbUrl, isFirstTime3DView);
                            isFirstTime3DView = true;
                } else { //  if (viewType == "image")
                    settingProductPageImagesMainSectionElement.style.display = "block";
                    // settingProductPageImagesMainSectionElement.innerHTML = `<img src="${this.dataset.imageSrc}" width="100%" height="100%" loading="eager">`;
                        }
            }

            const thumbnailImageActiveClass = "thumbnail-image--active", thumbnailSlickImageActiveClass = "slick-active";
            const settingThumbnailImageElements = RING_CREATOR_PDP.conObjToArrElements(".thumbnail-image.setting-thumbnail-image") || [],
                settingImageDotsElements = RING_CREATOR_PDP.conObjToArrElements(".slick-dots li") || [];
            if (settingThumbnailImageElements?.length > 0) {
                settingThumbnailImageElements.forEach((element) => {
                    element.addEventListener("click", async function () {
                        const viewType = this?.dataset?.type;
                        settingThumbnailImageElements.forEach((thumbnailImageElement) => thumbnailImageElement.classList.remove(thumbnailImageActiveClass));
                        this.classList.add(thumbnailImageActiveClass);
                        
                        settingImageDotsElements.forEach((settingImageDotsElement) => settingImageDotsElement.classList.remove(thumbnailSlickImageActiveClass));
                        loadOnClickForImages(viewType);
                    });
                });
            }
            
            if (settingImageDotsElements?.length > 0) {
                settingImageDotsElements.forEach((element) => {
                    element.addEventListener("click", async function () {
                        const viewType = this?.dataset?.type || "";
                        settingImageDotsElements.forEach((thumbnailImageElement) => thumbnailImageElement.classList.remove(thumbnailSlickImageActiveClass));
                        this.classList.add(thumbnailSlickImageActiveClass);                        
                        loadOnClickForImages(viewType);
                    });
                });
            }
        },
        addToCart: async function (_this, formData) {
            let _formData = formData;
            try {
                await fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(_formData)
                })
                .then((response) => {
                    return response.json();
                })
                .then(async (result) => {
                    if (result?.items?.length > 0) {
                        location.href = "/cart";
                        _this.removeAttribute("disabled", "disabled");
                        _this.classList.remove("disabled");
                        _this.textContent = "Buy this ring";
                        return;
                    } else {
                        $addDiamondToCartTry++;
                        if ($addDiamondToCartTry > 5) {
                            _this.removeAttribute("disabled", "disabled");
                            _this.classList.remove("disabled");
                            _this.textContent = "Buy this ring";
                            swal("Oops!", result?.message, "error");
                            return;
                        } else {
                            await RING_CREATOR_PDP.sleep(5000);
                            await window.RING_CREATOR_PDP.addToCart(_this, _formData);
                            return;
                        }
                    }
                })
                .catch(async (err) => {
                    $addDiamondToCartTry++;
                    if ($addDiamondToCartTry > 5) {
                        _this.removeAttribute("disabled", "disabled");
                        _this.classList.remove("disabled");
                        _this.textContent = "Buy this ring";
                        swal("Oops!", err?.message, "error");
                        return;
                    } else {
                        await RING_CREATOR_PDP.sleep(5000);
                        await window.RING_CREATOR_PDP.addToCart(_this, _formData);
                        return;
                    }
                });
            } catch (error) {
                console.log({ error: error });
            }
            _this.innerHTML = "Buy this ring";
            _this.disabled = false;
        },
        validateField: function (fieldType = "name", fieldName, fieldValue) {
            let regex;
            let errorMessage = "";
            switch (fieldType) {
                case "name":
                    regex = /^[a-zA-Z\s]+$/;
                    errorMessage = `${fieldName} is required.`;
                    break;
                case "email":
                    // Check for different email validation scenarios
                    if (fieldValue === "") {
                        errorMessage = "Email is required.";
                    } else if (!fieldValue.includes("@")) {
                        errorMessage = 'Email must contain an "@" symbol.';
                    } else if (fieldValue.startsWith("@") || fieldValue.endsWith("@")) {
                        errorMessage = 'Email cannot start or end with "@" symbol.';
                    } else if (!fieldValue.includes(".")) {
                        errorMessage = 'Email must contain a domain (e.g., ".com").';
                    } else if (fieldValue.split("@")[1].startsWith(".")) {
                        errorMessage = "Email domain cannot start with a period.";
                    } else {
                        regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                        if (!regex.test(fieldValue)) {
                            errorMessage = "Please enter a valid email address.";
                        }
                    }
                    break;
                case "phone":
                    // Check for different phone number validation scenarios
                    if (fieldValue === "") {
                        errorMessage = "Phone number is required.";
                    } else if (!/^\d+$/.test(fieldValue)) {
                        errorMessage = "Phone number must contain only digits.";
                    } else if (fieldValue.length < 10) {
                        errorMessage =
                            "Phone number is too short. It should be 10 digits long.";
                    } else if (fieldValue.length > 10) {
                        errorMessage =
                            "Phone number is too long. It should be 10 digits long.";
                    } else {
                        regex = /^\d{10}$/;
                        if (!regex.test(fieldValue)) {
                            errorMessage = "Please enter a valid 10-digit phone number.";
                        }
                    }
                    break;
                default:
                    return ""; // If the field doesn't need validation, return true
            }

            if (errorMessage) {
                return errorMessage;
            } else {
                return "";
            }
        },
        matchWordFromString: function (inputString, word) {
            const regex = new RegExp(`[^a-zA-Z0-9]*(${word})[^a-zA-Z0-9]*`);
            const match = inputString.match(regex);
            if (match) {
                return match[1];
            }
            return ""; // Return empty string if the word is not found
        },
        handleThreeDPart: async function (
            head_glb_url,
            shank_glb_url,
            isUpdate = false
        ) {
            // Select the metal color element
            const selectedMetalColorElement = document.querySelector(
                `.lineitem_prop[name="attributes[Metal]"]`
            );
            if (selectedMetalColorElement) {
                // Safely retrieve and clean the metal color slug and value
                let selectedMetalColorSlug =
                    selectedMetalColorElement?.dataset?.subOptionSlug
                        ?.split("-")
                        .join("_")
                        .trim() || "";
                let selectedMetalColorValue =
                    selectedMetalColorElement?.value?.trim() || "";

                // Handle platinum case and match the word 'platinum' if present
                if (selectedMetalColorSlug.includes("platinum")) {
                    selectedMetalColorSlug = RING_CREATOR_PDP.matchWordFromString(
                        selectedMetalColorSlug,
                        "platinum"
                    );
                }

                // Initialize metal head, shank, and dmat file from static data
                let metalHead =
                    three_d_static_data["pmat"][selectedMetalColorSlug] || "";
                let metalShank =
                    three_d_static_data["pmat"][selectedMetalColorSlug] || "";
                let dmatFile =
                    three_d_static_data["dmat"][selectedMetalColorSlug] || "";

                // If the metal color value contains '/', it's a combination (e.g., 18k/14k gold)
                if (selectedMetalColorValue.includes("/")) {
                    // Determine the carat size (either 18k or 14k)
                    const caratSize = selectedMetalColorValue.includes("18k")
                        ? "18k"
                        : "14k";

                    // Split the value to get head and shank components
                    const metalParts = selectedMetalColorValue
                        .replace(/14k|14K|18k|18K/g, "")
                        .trim()
                        .split("/");

                    // Construct slugs for metal head and shank
                    const selectedMetalShank =
                        `${caratSize}_${metalParts[0]}_gold`.toLowerCase();
                    const selectedMetalHead = `${caratSize}_${metalParts[metalParts.length - 1]
                        }_gold`.toLowerCase();

                    // Update metal head, shank, and dmat file based on the new slugs
                    metalHead = three_d_static_data["pmat"][selectedMetalHead] || "";
                    metalShank = three_d_static_data["pmat"][selectedMetalShank] || "";
                    dmatFile = three_d_static_data["dmat"][selectedMetalHead] || "";
                }

                // Log the results for debugging
                console.log({
                    selectedMetalColorSlug,
                    metalHead,
                    metalShank,
                    dmatFile,
                });

                // Generate the 3D media array using the metal head, shank, and dmat file
                const three_d_media_arr = RING_CREATOR_PDP.generateThreeDMediaArray(
                    head_glb_url,
                    shank_glb_url,
                    metalHead,
                    metalShank,
                    dmatFile
                );

                // Log the 3D media array and update flag
                console.log({ three_d_media_arr, isUpdate });

                // If media array is not empty, either update or initialize the 3D player
                if (three_d_media_arr.length > 0) {
                    if (isUpdate) {
                        window.player.update("webgl_setting_canvas", three_d_media_arr);
                    } else {
                        window.player.init("webgl_setting_canvas", three_d_media_arr);
                    }
                }
            } else {
                console.error("Metal color element not found");
            }
        },
        generateThreeDMediaArray: function (
            head,
            shank,
            metal_head,
            metal_shank,
            dmat
        ) {
            let three_d_media = [
                {
                    option_type: "model",
                    option_value: head,
                    option_identifier: "head",
                },
                {
                    option_type: "model",
                    option_value: shank,
                    option_identifier: "shank",
                },
                {
                    option_type: "material",
                    option_value: metal_head,
                    option_identifier: "metal-head",
                },
                {
                    option_type: "material",
                    option_value: metal_shank,
                    option_identifier: "metal-shank",
                },
                {
                    option_type: "material",
                    option_value: dmat,
                    option_identifier:
                        "stone-round,diamond-round,main-round,side-round,shank-round,main-round,main-oval,main-pear,main-emerald,side-round,main-cushion,main-princess,side-oval,main-asscher,main-heart,main-radiant,main-trillion,main-marquise,Gem",
                },
                {
                    option_type: "engrave",
                    option_value: {
                        size: 100,
                        font: "Inter",
                        text: document.getElementById("setting-inscription-input").value,
                        textColor: "#000000",
                        xOffset: 0,
                        yOffset: 0,
                        height: 2000,
                    },
                    option_identifier: "ring",
                },
            ];
            console.log(three_d_media);
            return three_d_media;
        },
        sleep: function(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
        setCookie: function(name, value, expirationInHours) {
            const date = new Date();
            date.setTime(date.getTime() + (expirationInHours * 60 * 60 * 1000)); // Convert hours to milliseconds
            const expires = "expires=" + date.toUTCString();
            document.cookie = `${name}=${value}; ${expires}; path=/`;
            // alert(`Cookie "${name}" has been set with value: "${value}", and will expire in ${Math.round(expirationInHours * 60 * 60)} seconds.`);
        },
        getCookie: function(name) {
            const decodedCookies = decodeURIComponent(document.cookie); // Decode cookies
            const cookiesArray = decodedCookies.split(';'); // Split into individual cookies
            for (let cookie of cookiesArray) {
                cookie = cookie.trim(); // Trim leading/trailing whitespace
                if (cookie.startsWith(name + "=")) {
                    return cookie.substring(name.length + 1); // Return the value of the cookie
                }
            }
            return null; // Return null if the cookie is not found
        },
        deleteCookie: function(name) {
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`; // Set expiration to a past date
        }
    };
})();

document.addEventListener("DOMContentLoaded", async function () {
    await RING_CREATOR_PDP.fetchProductRelatedAllData();
    if (RING_CREATOR_PDP.getUrlParameter("stone-stock") !== undefined) {
        await RING_CREATOR_PDP.fetchStoneProductByStockNumber();

      // Check Engraving Element
      (document.querySelector(`[data-is-empty-engraving="${(RING_CREATOR_PDP.getCookie("engravingText")?.length > 0 ? "No" : "Yes")}"]`)?.classList.remove('hide'));
    }
    await RING_CREATOR_PDP.initEventImagesOnClick();

    //3d inititialize from here
    window.player = new WebglPlayer();
});

const engravingPopupActiveClass = "product-page--engraving-popup--active", engravingPopupButtonActiveClass = "product-page--engraving-button-active";
if (RING_CREATOR_PDP.conObjToArrElements(".sr-product-page-engraving-popup")?.length > 0) {
    const srProductPageEngravingPopupElements = RING_CREATOR_PDP.conObjToArrElements(".sr-product-page-engraving-popup");
    srProductPageEngravingPopupElements.forEach(function (element) {
        element.addEventListener("click", function () {
            RING_CREATOR_PDP.conObjToArrElements(`.${engravingPopupActiveClass}`).forEach((e) => e.classList.remove(engravingPopupActiveClass));
            RING_CREATOR_PDP.conObjToArrElements(`.${engravingPopupButtonActiveClass}`).forEach((e) => e.classList.remove(engravingPopupButtonActiveClass));
            if (this.dataset.popup == "open") {
                element.classList.add(engravingPopupButtonActiveClass);
                document.querySelector(`.product-page--engraving-popup[data-popup-${this.dataset.popupType}]`).classList.add(engravingPopupActiveClass);
            }
        });
    });
}
if (document.getElementById("setting-inscription-input")) {
    document.getElementById("setting-inscription-input").addEventListener("input", function () {
        let value = this.value.trim(), maxLength = Number(this.getAttribute("maxlength"));
        document.querySelector(".product-page--engraving-field-info").innerText = `Characters Left ${maxLength - value.length}`;
        document.getElementById("setting-inscription-text").innerText =
        this.value.trim();
    });
}

const engravingActiveClass = "product-page--engraving-field-font--selected";
if (RING_CREATOR_PDP.conObjToArrElements(".settings-product-page-engraving-field-font")?.length > 0) {
    const engravingFontElements = RING_CREATOR_PDP.conObjToArrElements(".settings-product-page-engraving-field-font");
    engravingFontElements.forEach((element) => {
        element.addEventListener("click", function () {
            engravingFontElements.forEach((engravingFontElement) => engravingFontElement.classList.remove(engravingActiveClass));
            this.classList.add(engravingActiveClass);
            if (this.dataset?.fontFamily?.length > 0) {
                const font = this.dataset.fontFamily;
                const settingInscriptionTextElement = document.getElementById("setting-inscription-text");
                settingInscriptionTextElement.classList = "";
                settingInscriptionTextElement.className = `product-page--engraving-preview-text ${font}`;
            }
        });
    });
}

if (document.getElementById("setting-product-page-engraving-button")) {
    document.getElementById("setting-product-page-engraving-button").addEventListener("click", async function () {
        const settingEngravingValue = document.getElementById("setting-inscription-input").value.trim();
        // const selectedEngravingFont = document.querySelector('.settings-product-page-engraving-field-font.product-page--engraving-field-font--selected');
        RING_CREATOR_PDP.deleteCookie("engravingText");
        // RING_CREATOR_PDP.deleteCookie('engravingFont');
        // RING_CREATOR_PDP.deleteCookie('engravingFontFamily');
        if (settingEngravingValue?.length > 0) {
            //  && selectedEngravingFont?.dataset?.fontFamilyName?.length > 0
            document.querySelector("[data-engraving-span-text]") && (document.querySelector("[data-engraving-span-text]").innerText = "Edit Engraving");
            document.querySelector("[data-review-inscription-text]") && (document.querySelector("[data-review-inscription-text]").innerText = settingEngravingValue);
            RING_CREATOR_PDP.conObjToArrElements(`.${engravingPopupActiveClass}`).forEach((e) => e.classList.remove(engravingPopupActiveClass));
            RING_CREATOR_PDP.conObjToArrElements(`.${engravingPopupButtonActiveClass}`).forEach((e) => e.classList.remove(engravingPopupButtonActiveClass));
            RING_CREATOR_PDP.setCookie("engravingText", settingEngravingValue, 2);
            // RING_CREATOR_PDP.setCookie('engravingFont', selectedEngravingFont.dataset.fontFamilyName, 2);
            // RING_CREATOR_PDP.setCookie('engravingFontFamily', selectedEngravingFont.dataset.fontFamily, 2);

          if (RING_CREATOR_PDP.getUrlParameter("stone-stock") !== undefined) {
            document.querySelector('[data-is-empty-engraving="Yes"]') && (document.querySelector('[data-is-empty-engraving="Yes"]').classList.add('hide'));
            document.querySelector('[data-is-empty-engraving="No"]') && (document.querySelector('[data-is-empty-engraving="No"]').classList.remove('hide'));
          }
        }

        if (document.querySelector(".thumbnail-image.setting-thumbnail-image.thumbnail-image--active")?.dataset?.type == "3D_view") {
            await RING_CREATOR_PDP.handleThreeDPart(RING_CREATOR_PDP.config.headGlbUrl, RING_CREATOR_PDP.config.shankGlbUrl, true);
        }
    });
}

if (document.getElementById("setting-product-page-select-ring-size")) {
    document.getElementById("setting-product-page-select-ring-size").addEventListener("change", function () {
        const selectedRingSize = this.value;
        RING_CREATOR_PDP.deleteCookie("ringSize");
        if (selectedRingSize?.length > 0) {
            RING_CREATOR_PDP.setCookie("ringSize", selectedRingSize, 2);
        }
    });
}

if (document.getElementById("setting-product-page-cta-button")) {
    document.getElementById("setting-product-page-cta-button").addEventListener("click", function () {
        const settingProductPageSelectRingSize = document.getElementById("setting-product-page-select-ring-size");
        const stepsParams = RING_CREATOR_PDP.getUrlParameter("steps") != undefined ? "&steps=settings" : "";
            if (settingProductPageSelectRingSize?.value > 0) {
            RING_CREATOR_PDP.setCookie("ringSize", settingProductPageSelectRingSize?.value, 2);
                if (RING_CREATOR_PDP.getUrlParameter("stone-stock") != undefined) {
                location.href = `/products/${setting_hdn_prod_handle.value}?stone-stock=${RING_CREATOR_PDP.getUrlParameter("stone-stock")}&review=true${stepsParams}`;
                } else {
                const shapeValue = document.querySelector(`.lineitem_prop[data-name="Shape"]`).value.trim();
                    location.href = `/collections/lab-created-diamonds?ring-handle=${setting_hdn_prod_handle.value}&shape=${shapeValue}&review=true${stepsParams}`;
                }
            } else {
                swal("Please select the ring size.");
            }
        });
}

if (document.getElementById("review-product-page-cta-button")) {
    document
        .getElementById("review-product-page-cta-button")
        .addEventListener("click", async function () {
            let _this = this;
            let productObj = RING_CREATOR_PDP.config.selectStoneProduct;

            _this.setAttribute("disabled", "disabled");
            _this.classList.add("disabled");
            _this.textContent = "Adding item...";
            if (Object.keys(productObj)?.length > 0) {
                var formData = new FormData();
                formData.append("action", "createProduct");
                formData.append("shop", Shopify.shop);
                formData.append("product_title", productObj?.long_title);
                formData.append("product_price", productObj?.total_sales_price);
                formData.append("stock_id", productObj?.id);
                formData.append("stock_num", productObj?.stock_num);
                formData.append(
                    "product_img",
                    productObj?.image_url?.length > 0
                        ? productObj?.image_url
                        : `${window.location.origin}${baseAppProxy}/images/no-image.png`
                );

                await fetch(`${baseAppProxy}/frontend.php`, {
                    method: "POST",
                    body: formData,
                })
                    .then((response) => response.text())
                    .then(async (result) => {
                        let resultObj = JSON.parse(result);
                        if (resultObj.isSuccess == "1") {
                            var groupId = Array.from(Array(30), () =>
                                Math.floor(Math.random() * 36).toString(36)
                            ).join("");
                            var tempGroupId = groupId;
                            if (resultObj.isSuccess == "1") {
                                var groupId = Array.from(Array(30), () =>
                                    Math.floor(Math.random() * 36).toString(36)
                                ).join("");
                                var tempGroupId = groupId;
                                let items = {
                                    'items': [
                                        {
                                            id: document.getElementById("setting_hdn_prod_var_id").value,
                                            quantity: 1,
                                            properties: {
                                                _groupId: tempGroupId,
                                                Metal: RING_CREATOR_PDP.config.Metal || "",
                                                Shape: RING_CREATOR_PDP.config.Shape || "",
                                                Crown: RING_CREATOR_PDP.config.Crown || "",
                                                Shank: RING_CREATOR_PDP.config.Shank || "",
                                                "Ring Size": RING_CREATOR_PDP.getCookie("ringSize") || "",
                                                Engraving: RING_CREATOR_PDP.getCookie("engravingText") || "",
                                                // 'engravingFont': RING_CREATOR_PDP.getCookie('engravingFont') || '',
                                            },
                                        },
                                        {
                                            id: resultObj.var_id,
                                            quantity: 1,
                                            properties: {
                                                _groupId: tempGroupId,
                                                Color: productObj?.color,
                                                Clarity: productObj?.clarity,
                                            },
                                        },
                                    ]
                                };
                                $addDiamondToCartTry = 0;
                                await RING_CREATOR_PDP.addToCart(_this, items);
                            }
                        }
                    });
            } else {
                swal("Oops!", "Something went wrong please try again later!", "error");

                _this.removeAttribute("disabled", "disabled");
                _this.classList.remove("disabled");
                _this.textContent = "Buy this ring";
                return;
            }
        });
}

if (
    RING_CREATOR_PDP.conObjToArrElements(".setting-ring-sizer-guide-popup")
        ?.length > 0
) {
    RING_CREATOR_PDP.conObjToArrElements(
        ".setting-ring-sizer-guide-popup"
    ).forEach((element) => {
        element.addEventListener("click", function () {
            const customViewRingSizePopupElement = document.getElementById(
                "custom-view-ring-size-popup"
            );
            customViewRingSizePopupElement.classList.remove("hidden");
            if (this.dataset.ringSize == "close") {
                customViewRingSizePopupElement.classList.add("hidden");
            }
        });
    });
}

const popupActiveClass = "active-popup";
const popupShareTipSuccessClass = "share-tip-popup-success";
if (
    RING_CREATOR_PDP.conObjToArrElements(".share-tip-popup-action")?.length > 0
) {
    RING_CREATOR_PDP.conObjToArrElements(".share-tip-popup-action").forEach(
        (element) => {
            element.addEventListener("click", function (e) {
                e.preventDefault();
                document.getElementById("st-name").value = "";
                document.getElementById("st-email").value = "";
                document.getElementById("st-recipient-email").value = "";
                document.getElementById("st-note").value = "";
                document.getElementById("st-copy-email").checked = false;
                document.getElementById("st-email-updates").checked = false;

                document.getElementById("st-err-name").innerText = "";
                document.getElementById("st-err-email").innerText = "";
                document.getElementById("st-err-recipient-email").innerText = "";
                if (document.getElementById("share-tip-popup")) {
                    document
                        .getElementById("share-tip-popup")
                        .classList.toggle(popupActiveClass);
                    document
                        .getElementById("share-tip-popup")
                        .classList.remove(popupShareTipSuccessClass);
                }
                if (document.querySelector(".close-btn")) {
                    document.querySelector(".close-btn").click();
                }
                if (document.getElementById("send-share-tip-popup-btn")) {
                    document.getElementById("send-share-tip-popup-btn").innerText =
                        "Send";
                    document.getElementById("send-share-tip-popup-btn").disabled = false;
                }
            });
        }
    );
}

if (document.getElementById("send-share-tip-popup-btn")) {
    document
        .getElementById("send-share-tip-popup-btn")
        .addEventListener("click", async function (e) {
            e.preventDefault();
            const _this = this;
            _this.innerText = "Please wait...";
            _this.disabled = true;

            const name = document.getElementById("st-name").value.trim();
            const email = document.getElementById("st-email").value.trim();
            const recipientEmail = document
                .getElementById("st-recipient-email")
                .value.trim();
            const note = document.getElementById("st-note").value.trim();
            const copyEmail = document.getElementById("st-copy-email").checked;
            const emailUpdates = document.getElementById("st-email-updates").checked;

            const errName = document.getElementById("st-err-name");
            const errEmail = document.getElementById("st-err-email");
            const errRecipientEmail = document.getElementById(
                "st-err-recipient-email"
            );

            errName.innerText = !name
                ? RING_CREATOR_PDP.validateField("name", "Name", name)
                : "";
            errEmail.innerText = !email
                ? RING_CREATOR_PDP.validateField("email", "Email", email)
                : "";
            errRecipientEmail.innerText = !recipientEmail
                ? RING_CREATOR_PDP.validateField(
                    "name",
                    "Recipient's Email",
                    recipientEmail
                )
                : "";
            if (name && email && recipientEmail) {
                try {
                    var formData = new FormData();
                    formData.append("action", "shareProductToEmail");
                    formData.append("shop", Shopify.shop);
                    formData.append("sender_name", name);
                    formData.append("sender_email_address", email);
                    formData.append("emails", recipientEmail);
                    formData.append("share_message", note);
                    formData.append("copy_email", copyEmail == true ? "Yes" : "No");
                    formData.append("email_updates", emailUpdates == true ? "Yes" : "No");
                    formData.append(
                        "product_id",
                        document.getElementById("setting_hdn_prod_id").value.trim()
                    );
                    formData.append(
                        "product_title",
                        document.getElementById("setting_hdn_prod_title").value.trim()
                    );
                    formData.append("product_url", location.href);

                    const needHelpProdInfo = await RING_CREATOR_PDP.fetchData(formData);
                    if (needHelpProdInfo?.SUCCESS === "TRUE") {
                        document.getElementById("share-tip-popup") &&
                            document
                                .getElementById("share-tip-popup")
                                .classList.add(popupShareTipSuccessClass);
                    }
                    _this.innerText = "Send";
                    _this.disabled = false;
                } catch (error) {
                    console.log({ error });
                }
            } else {
                _this.innerText = "Send";
                _this.disabled = false;
            }
        });
}

const popupNeedHelpSuccessClass = "need-help-popup-success";
if (
    RING_CREATOR_PDP.conObjToArrElements(".need-help-popup-action")?.length > 0
) {
    RING_CREATOR_PDP.conObjToArrElements(".need-help-popup-action").forEach(
        (element) => {
            element.addEventListener("click", function (e) {
                e.preventDefault();
                document.getElementById("nh-first-name").value = "";
                document.getElementById("nh-last-name").value = "";
                document.getElementById("nh-email").value = "";
                document.getElementById("nh-phone").value = "";
                document.getElementById("nh-message").value = "";
                document.getElementById("nh-new-styles").checked = false;

                document.getElementById("nh-err-first-name").innerText = "";
                document.getElementById("nh-err-last-name").innerText = "";
                document.getElementById("nh-err-email").innerText = "";
                document.getElementById("nh-err-message").innerText = "";
                if (document.getElementById("need-help-popup")) {
                    document
                        .getElementById("need-help-popup")
                        .classList.toggle(popupActiveClass);
                    document
                        .getElementById("need-help-popup")
                        .classList.remove(popupNeedHelpSuccessClass);
                }
                if (document.getElementById("need-help-popup-btn")) {
                    document.getElementById("need-help-popup-btn").innerText = "Send";
                    document.getElementById("need-help-popup-btn").disabled = false;
                }
            });
        }
    );
}

if (document.getElementById("send-need-help-popup-btn")) {
    document.getElementById("send-need-help-popup-btn").addEventListener("click", async function (e) {
        e.preventDefault();
        const _this = this;
        _this.innerText = "Please wait...";
        _this.disabled = true;

        const firstName = document.getElementById("nh-first-name").value.trim();
        const lastName = document.getElementById("nh-last-name").value.trim();
        const email = document.getElementById("nh-email").value.trim();
        const phone = document.getElementById("nh-phone").value.trim();
        const message = document.getElementById("nh-message").value.trim();
        const newStyles = document.getElementById("nh-new-styles").checked;

        const errFirstName = document.getElementById("nh-err-first-name");
        const errLastName = document.getElementById("nh-err-last-name");
        const errEmail = document.getElementById("nh-err-email");
        const errMessage = document.getElementById("nh-err-message");

        errFirstName.innerText = !firstName ? RING_CREATOR_PDP.validateField("name", "First name", firstName) : "";
        errLastName.innerText = !lastName ? RING_CREATOR_PDP.validateField("name", "Last name", lastName) : "";
        errEmail.innerText = !email ? RING_CREATOR_PDP.validateField("email", "Email", email) : "";
        errMessage.innerText = !message ? RING_CREATOR_PDP.validateField("name", "Message", message) : "";
        if (firstName && lastName && email && message) {
            try {
                var formData = new FormData();
                formData.append("action", "insertQuery");
                formData.append("shop", Shopify.shop);
                formData.append("first_name", firstName);
                formData.append("last_name", lastName);
                formData.append("email", email);
                formData.append("phone", phone);
                formData.append("message", message);
                formData.append("product_id", document.getElementById("setting_hdn_prod_id").value.trim());
                formData.append("product_title", document.getElementById("setting_hdn_prod_title").value.trim());
                formData.append("new_styles", newStyles == true ? "Yes" : "No");
                formData.append("product_url", location.href);

                const needHelpProdInfo = await RING_CREATOR_PDP.fetchData(formData);
                if (needHelpProdInfo?.SUCCESS === "TRUE") {
                    document.getElementById("need-help-popup") && document.getElementById("need-help-popup").classList.add(popupNeedHelpSuccessClass);
                }
                _this.innerText = "Send";
                _this.disabled = false;
            } catch (error) {
                console.log({ error });
            }
        } else {
            _this.innerText = "Send";
            _this.disabled = false;
        }
    });
}
